import HttpService from "./htttp.service";

// Pedidos de orçamento. Sempre pelo uuid: pedido bloqueado não traz id.
class LeadService {
  // Vitrine: pedidos abertos que qualquer DJ pode liberar
  getAvailable = async () => {
    const res = await HttpService.get("leads");
    return Array.isArray(res) ? res : res?.data || [];
  };

  // Pedidos vinculados ao DJ (liberados, diretos e manuais)
  getMine = async () => {
    const res = await HttpService.get("leads/my-leads");
    return Array.isArray(res) ? res : res?.data || [];
  };

  // { count, available_count }
  getPendingCount = async () => await HttpService.get("leads/pending-count");

  // 200 { status: "unlocked", lead, unlocks_remaining } | 200 { status: "checkout", url, unlock_price }
  unlock = async (uuid) => await HttpService.post(`leads/${uuid}/unlock`);

  // { status: "confirmed" | "processing" | "pix_pending" | "failed", lead? }
  getUnlockStatus = async (sessionId) =>
    await HttpService.get(`leads/unlock-status?session_id=${encodeURIComponent(sessionId)}`);

  accept = async (uuid) => await HttpService.post(`leads/${uuid}/accept`);

  reject = async (uuid) => await HttpService.post(`leads/${uuid}/reject`);

  remove = async (uuid) => await HttpService.delete(`leads/${uuid}`);

  // Premium
  createManual = async (payload) => await HttpService.post("leads/manual", payload);

  // Premium
  convert = async (uuid, payload) => await HttpService.post(`dj/leads/${uuid}/convert`, payload);
}

export default new LeadService();
